<div *ngFor="let loaLevel of memoLoaPreviews; last as isLastLevel"
    class="container-loa-level"
    [ngClass]="'status-' + loaLevel.status">
  <div *ngIf="showLevel"
      class="d-flex align-items-center">
    <div class="col-auto">
      <div class="level-checkpoint"
          [style.background-color]="_loaStatusColors[loaLevel.status]?.background"
          [style.color]="_loaStatusColors[loaLevel.status]?.foreground"
          [style.box-shadow]="!!loaStatusIcons[loaLevel.status]
            ? '0px 6px 16px 0px ' + _loaStatusColors[loaLevel.status]?.background + '3d'
            : 'none'">
        <ng-container [ngSwitch]="!!loaStatusIcons[loaLevel.status]">
          <svg-icon *ngSwitchCase="true"
              [src]="loaStatusIcons[loaLevel.status]!"
              [svgStyle]="{ 'height.px': 29, stroke: 'currentColor', 'width.px': 27 }">
          </svg-icon>
          <label *ngSwitchDefault
              class="h4 fw-bold mb-0">{{ loaLevel.level }}</label>
        </ng-container>
      </div>
    </div>
    <div class="col px-2">
      <label class="fs-base-l0 fs-std-5 fw-md-semibold mb-0">
        {{ 'MEMOS.LOA-PREVIEW.LEVEL' | translate }} {{ loaLevel.level }}
      </label>
    </div>
    <div *ngIf="showBadge"
        class="col-auto d-flex align-items-lg-center">
      <div class="badge badge-std rounded-pill fw-medium"
          [style.background-color]="_loaStatusColors[loaLevel.status]?.background"
          [style.color]="_loaStatusColors[loaLevel.status]?.foreground">
        <div *ngIf="remindMemo === 'remind'">
          {{ loaLevel.progress.current }}/{{ loaLevel.progress.total }} {{ 'MEMOS.Approver' | translate }}
        </div>
        <div *ngIf="remindMemo !== 'remind'">
          <ng-container [ngSwitch]="isShowProgress(loaLevel.status)">
            <span *ngSwitchCase="true">
              {{ loaLevel.progress.current }}/{{ loaLevel.progress.total }}
              {{ 'MEMOS.LOA-PREVIEW.Signature required' | translate }}
            </span>
            <span *ngSwitchDefault>
              {{ language === 'en' ? loaBadge[loaLevel.status] : loaBadgeTh[loaLevel.status] }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex py-2">
    <div *ngIf="showLevel"
        class="col-auto vertical-line">
      <div class="line"
          [class.invisible]="isLastLevel"
          [style.background-color]="loaLevel.status === 'approved' 
            ? _loaStatusColors['approved']?.background
            :  loaLevel.status ==='pending' ?  '#1750C0' : '#B8CBF1'">
      </div>
    </div>
    <div class="col pb-2">
      <ng-container *ngFor="let member of loaLevel.members; let index = index">
        <div class="container-member d-flex align-items-center mt-2"
            [ngClass]="'status-' + member.status">
          <div class="col-auto">
            <input *ngIf="remindMemo === 'remind'"
                type="checkbox"
                class="checkbox-default ms-2"
                (change)="noChangeLoaMemberRemind(member.id)"
                [disabled]="!member.can_send_reminder">
            <div *ngIf="remindMemo !== 'remind'"
                class="d-flex flex-column justify-content-center">
              <svg alt="Check Circle"
                  height="16"
                  width="16"
                  viewBox="0 0 16 16"
                  [style.color]="approverStatusColors[member.status]?.foreground">
                <circle cx="50%"
                    cy="50%"
                    r="50%"
                    [attr.fill]="approverStatusColors[member.status]?.background" />
                <use height="12"
                    width="12"
                    x="2"
                    y="2"
                    stroke="currentColor"
                    [attr.href]="memberStatusIcons[member.status]">
                </use>
              </svg>
            </div>
          </div>
          <div class="col-auto px-l6">
            <app-profile-display [person]="member"
                [borderColor]="approverStatusBorderColors[member.status]"></app-profile-display>
          </div>
          <div class="col align-self-stretch">
            <div class="grid-member-detail">
              <ng-container [ngSwitch]="loaLevel.status !== 'canceled'
                  && member.status !== 'canceled'
                  && member.status !== 'not_started'">
                <div class="fullname">
                  <label class="fs-l1 fs-base-md-u0 fw-md-semibold mb-0">{{ member.full_name }}</label>
                </div>
                <div *ngSwitchCase="true"
                    class="section d-none d-md-flex flex-column justify-content-center text-end"
                    [style.grid-row]="member.date_of_approve ? 1 : '1 / span 2'">
                  <label *ngIf="remindMemo!=='remind' && !showDigitalSign"
                      class="fw-medium small mb-0 text-blue-sapphire">
                    {{ 'COMMON.Digital Signature Section' | translate }} {{ member.section }}
                  </label>
                </div>
                <div *ngIf="member.is_custom"
                    class="subname justify-content-between flex-column align-items-start mt-1">
                  <div class="d-flex align-items-center">
                    <div *ngIf="showDigitalSign"
                        class=" px-1 fw-medium fs-base-l7 text-blue-sapphire">
                      {{ 'COMMON.External User' | translate }}
                    </div>
                    <div *ngIf="showDigitalSign"
                        class=" px-1 fw-medium fs-base-l7"
                        [class.text-blue-sapphire]="loaStatusColors !== 'theme'"
                        [class.text-std-color-3]="loaStatusColors === 'theme'">
                      <span class="border-start me-2"></span>
                      {{ 'COMMON.Digital Signature Section' | translate }} {{ member.section }}
                    </div>
                    <label *ngIf="member.is_delegate"
                        class="bagde rounded-pill badge-transfer mb-0 ms-1">
                      {{ 'LOA.DELEGATE' | translate }}
                    </label>
                  </div>
                  <div *ngIf="member.email"
                      class="rounded-pill fs-base-l7 border-detail">
                    <svg class="icon-btn-svg me-1"
                        stroke="currentColor">
                      <use href="assets/images/icons/documents/envelope2.svg#envelope2"
                          y="1"
                          height="18"
                          width="20">
                      </use>
                    </svg>
                    <span class="me-2 text-gray-neutrals">
                      {{ member.email }}
                    </span>
                  </div>
                  <div class="d-flex mt-1">
                    <div *ngIf="member.position"
                        class="me-1 rounded-pill fs-base-l7 border-detail">
                      <svg class="icon-btn-svg me-1"
                          stroke="currentColor">
                        <use href="assets/images/icons/objects/bucket.svg#bucket"
                            y="1"
                            height="18"
                            width="20">
                        </use>
                      </svg>
                      <span class="me-2 text-gray-neutrals">
                        {{ member.position }}
                      </span>
                    </div>
                    <div *ngIf="member.phone_number"
                        class="rounded-pill fs-base-l7 border-detail">
                      <svg class="icon-btn-svg me-1"
                          stroke="currentColor">
                        <use href="assets/images/icons/communications/telephone.svg#telephone"
                            y="2"
                            height="15"
                            width="20">
                        </use>
                      </svg>
                      <span class="me-2 text-gray-neutrals">
                        {{ member.phone_number || '-' | phone }}
                      </span>
                    </div>
                  </div>

                  <div *ngIf="showDigitalSign && member.date_of_approve_since"
                      class="d-none d-md-flex fs-base-l7 text-gray mt-1">
                    {{ member.date_of_approve | date: 'dd/MM/yyyy' }} ({{ member.date_of_approve | date: 'HH:mm' }})
                  </div>
                  <div class="d-flex d-md-none align-items-center d-md-none text-gray justify-content-end mb-0">
                    <label class="small mb-0">{{ member.date_of_approve | date: 'dd/MM/yyyy' }}</label>
                    <label *ngIf="member.date_of_approve_since"
                        class="small mb-0 ms-1">
                      ({{ member.date_of_approve_since }})
                    </label>
                  </div>
                </div>

                <div *ngIf="!member.is_custom"
                    class="subname justify-content-between flex-column align-items-start position-relative">
                  <div class="d-flex align-items-center">
                    <label class="small text-black-deep mb-0 me-2">{{ member.nickname || '-' }}</label>
                    <div *ngIf="showDigitalSign"
                        class="px-1 fw-medium fs-base-l7"
                        [class.text-blue-sapphire]="loaStatusColors !== 'theme'"
                        [class.text-std-color-3]="loaStatusColors === 'theme' && highlightApproveDate">
                      <span class="border-start me-2"></span>
                      <ng-container *ngIf="highlightApproveDate; else noHighlight">
                        <span>
                          {{ 'COMMON.Digital Signature Section' | translate }} {{ member.section }}
                        </span>
                      </ng-container>
                      <ng-template #noHighlight>
                        <span class="fs-base-l7 text-gray-neutrals">
                          {{ member.position }}
                        </span>
                      </ng-template>
                    </div>
                    <label *ngIf="member.is_delegate"
                        class="bagde rounded-pill badge-transfer mb-0 ms-1">
                      {{ 'LOA.DELEGATE' | translate }}
                    </label>
                  </div>
                  <div *ngIf="showDigitalSign && member.date_of_approve_since"
                      class="fs-base-l7 text-gray date-approve-since d-none d-md-flex"
                      [ngClass]="{'badge badge-std rounded-pill position-absolute highlight' : !highlightApproveDate}"
                      [style.background-color]="highlightApproveDate ? 'transparent' : _loaStatusColors[loaLevel.status]?.background"
                      [style.color]="highlightApproveDate ? '#a4a4a4' :_loaStatusColors[loaLevel.status]?.foreground">
                    {{ member.date_of_approve | date: 'dd/MM/yyyy' }} ({{ member.date_of_approve | date: 'HH:mm' }})
                  </div>
                  <div class="d-flex align-items-center d-md-none text-gray justify-content-end mb-0">
                    <label class="small mb-0">{{ member.date_of_approve | date: 'dd/MM/yyyy' }}</label>
                    <label *ngIf="member.date_of_approve_since"
                        class="small mb-0 ms-1">
                      ({{ member.date_of_approve_since }})
                    </label>
                  </div>
                </div>
                <div *ngSwitchCase="true"
                    class="date d-none d-md-flex justify-content-end">
                  <label *ngIf="remindMemo !== 'remind' && !showDigitalSign"
                      class="small mb-0 text-gray-roman-silver">
                    {{ member.date_of_approve | date: 'dd/MM/yyyy' }}
                    <span *ngIf="member.date_of_approve_since">({{ member.date_of_approve_since }})</span>
                  </label>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="isShowReason(member.status)"
            class="row g-0 mt-2">
          <label class="form-control round-input disable p-2">
            {{ member.reason }}
          </label>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div *ngIf="!memoLoaPreviews?.length && highlightApproveDate"
    class="content-empty">
  <app-svg-page-placeholder class="w-100"
      title="MEMOS.LOA-PREVIEW.There’re not line of approval"
      subTitle="MEMOS.LOA-PREVIEW.Please add approver to Memo"
      [backgroundImage]="{
        y: '50px'
      }"
      [height]="130"
      [standImage]="{
        fill: '#9da0ab',
        src: 'assets/images/pictograms/person.svg#person',
        stroke: '#eaeaed',
        width: '86px',
        height: '106px',
      }">
  </app-svg-page-placeholder>
</div>